import * as PapaParse from 'papaparse';
import { User } from '../../types/user';
export const parseCSVToUser = (csvInput: string): Partial<User>[] => {
  const users: Partial<User>[] = PapaParse.parse<Partial<User>>(csvInput, {
    header: true,
    skipEmptyLines: true,
  }).data;
  return users;
};
